import React from "react"
import FieldRating from "../../rating";


type FieldRatingGlistGroupProps = {
    field           : FieldRating
    glist           : any
    data            : any,
    isCollapsed?    : boolean
};


export default function FieldRating_GlistGroupModern(props:FieldRatingGlistGroupProps) {

    const value = props.data.value

    const stars = new Array(props.field.scale).fill(true).fill(false, value);

    return (
        <div className="ui5-chip s30 gray">
            {_.map(stars, (value, key)=>{
                const classes = Classes("icon", {
                    'filled i5-star': value,
                    'empty i5-star-empty': !value,
                });
                return <div key={key} className={classes}/>
            })}
        </div>
    );
}